import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FileBarChart, Handshake } from "lucide-react";

export const StickyCTA = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <div data-testid="sticky-cta" className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-dc-bg/95 backdrop-blur-md border-t border-dc-border p-3 flex gap-2">
      <button
        data-testid="sticky-cta-assessment"
        onClick={() => navigate("/contact")}
        className="flex-1 flex items-center justify-center gap-2 bg-dc-accent text-dc-bg font-semibold text-[13px] py-3"
      >
        <FileBarChart size={15} /> Assess Waste
      </button>
      <button
        data-testid="sticky-cta-partner"
        onClick={() => navigate("/partners")}
        className="flex-1 flex items-center justify-center gap-2 border border-dc-borderHi text-white text-[13px] py-3"
      >
        <Handshake size={15} /> Trading Partner
      </button>
    </div>
  );
};
